import axios from "axios";
import jwt from "jwt-decode";

const getAxiosInstance = () => {
    const currentAccessToken = localStorage.getItem("cineonhub_access_token");
    const currentRefreshToken = localStorage.getItem("cineonhub_access_refreshToken");

    const axiosInstance = axios.create({
        baseURL: process.env.REACT_APP_API_ENDPOINT,
        headers: {
            Authorization: `Bearer ${currentAccessToken}`,
        },
    });

    axiosInstance.interceptors.request.use(async function (config) {
        const nowInSeconds = Math.round(Date.now() / 1000);

        // currentAccessTokenが期限切れの場合、refreshTokenを渡してcurrentAccessTokenを更新させる
        if (currentAccessToken && currentRefreshToken) {
            let accessTokenDecoded: any;
            try {
                accessTokenDecoded = jwt(currentAccessToken);
            } catch (e) {
                // 強制的にログアウトさせる
                localStorage.removeItem("cineonhub_access_token");
                window.location.href = `/#/sessionTimeout`;
            }
            if (accessTokenDecoded.exp < nowInSeconds) {
                let account = null;
                const authURL = "-" + process.env.REACT_APP_AUTH_DOMAIN + "-";
                const item = Object.keys(localStorage);
                for (let i = 0; i < item.length; i++) {
                    if (item[i].includes(authURL)) {
                        const current = localStorage.getItem(item[i]);
                        if (current && current.includes("idTokenClaims")) {
                            account = JSON.parse(current);
                        }
                    }
                }

                if (account) {
                    await axios
                        .post(`${process.env.REACT_APP_API_ENDPOINT}/api/refreshToken`, {
                            fullName:
                                account.idTokenClaims.family_name +
                                " " +
                                account?.idTokenClaims.given_name,
                            isNew: account.idTokenClaims.newUser ? true : false,
                            profileImageUrl: "",
                            organization: account.idTokenClaims.extension_organization,
                            localAccountId: account.localAccountId,
                            refreshToken: currentRefreshToken,
                        })
                        .then(({ data }) => {
                            const newAccessToken = data.token;
                            localStorage.setItem("cineonhub_access_token", newAccessToken);
                            if (config.headers)
                                config.headers.Authorization = `Bearer ${newAccessToken}`;
                            return config;
                        })
                        .catch((error) => {
                            // refreshTokenが期限切れの場合、強制的にログアウトさせる
                            localStorage.removeItem("cineonhub_access_token");
                            window.location.href = `/#/sessionTimeout`;
                            return;
                        });
                } else {
                    // 強制的にログアウトさせる
                    localStorage.removeItem("cineonhub_access_token");
                    window.location.href = `/#/sessionTimeout`;
                }
            }
        } else {
            // 強制的にログアウトさせる
            localStorage.removeItem("cineonhub_access_token");
            window.location.href = `/#/sessionTimeout`;
        }
        return config;
    });

    return axiosInstance;
};

export default getAxiosInstance;
